'use client';
import { prepare_virtualPageUrl } from '@/lib/data-layer/utils';
import WebPageSchema from '@/src/features/schema/WebPageSchema';
import DataLayerPageComponent from '@/src/features/shared/data-layer-component/';
import EmailSubscription from '@/src/features/shared/email-subscription';
import { Breadcrumb } from '@/src/features/ui/breadcrumb';
import { BreadcrumbType } from '@/src/features/ui/breadcrumb/types';
import { InnerContainer } from '@/src/features/ui/common/inner-container';
import RoundedContainer from '@/src/features/ui/rounded-container';
import { DeviceContext } from '@/src/store/contexts/device-context';
import { notFound, useSearchParams } from 'next/navigation';
import { useContext } from 'react';
import { LegalTexts } from './legal-texts';
import { mockData } from './mock-data';

type Props = {
  pageName: string | null;
};

const Page: React.FC<Props> = ({ pageName }) => {
  const searchParams = useSearchParams();
  const { isMobile } = useContext(DeviceContext);

  let template, mainTitle;

  try {
    template = mockData[`${pageName}`]?.template;
    mainTitle = mockData[`${pageName}`]?.mainTitle;
  } catch (error) {
    console.error(`Error accessing mockData for ${pageName}:`, error);
    notFound();
  }

  if (!template || !mainTitle) {
    notFound();
  }

  const canonicalUrl = `hakkimizda/${pageName}`;
  const breadcrumbList: BreadcrumbType = [
    { title: 'Hakkımızda', url: '/hakkimizda' },
    {
      title: mockData[`${pageName}`]?.urlTitle,
      url: null,
    },
  ];

  const prepareVirtualPageUrl = prepare_virtualPageUrl({
    pathname: `/hakkimizda/${pageName}`,
    searchParams: searchParams,
  });

  const prepareDataLayerData = {
    page: {
      ...mockData[`${pageName}`]?.page,
      virtualPageUrl: prepareVirtualPageUrl,
    },
    otherData: { ...mockData[`${pageName}`]?.seoInfo },
  };
  return (
    <>
      <WebPageSchema canonicalPath={canonicalUrl} seoInfo={mockData[`${pageName}`]?.seoInfo} />
      <DataLayerPageComponent type="page" argms={prepareDataLayerData} />
      <Breadcrumb breadcrumbList={breadcrumbList} path={`hakkimizda/${pageName}`} />

      <div className="mb-8 md:mb-16">
        <div className="md:mb-46 flex h-36 items-center bg-purple500 md:h-56">
          <InnerContainer>
            <span className="flex items-center justify-center text-center font-bold text-white md:text-3xl">
              {mainTitle}
            </span>
          </InnerContainer>
        </div>
      </div>

      <InnerContainer>
        <section className="mb-20">
          <div className="md:flex md:justify-between">
            <LegalTexts legalTexts={mockData} />
            <div className="md:pl-8">
              <RoundedContainer noShadow={isMobile}>
                <div
                  className="text-sm md:p-4"
                  dangerouslySetInnerHTML={{
                    __html: template,
                  }}
                />
              </RoundedContainer>
            </div>
          </div>
        </section>
      </InnerContainer>
      <EmailSubscription pageId={''} />
    </>
  );
};

export default Page;
